import { orpc } from '@/lib/orpc/react';

export const servicesQueries = {
  list: (status: 'all' | 'draft' | 'active' | 'archived' = 'all') =>
    orpc.dashboard.services.list.queryOptions({ input: { status } }),
  get: (id: string) =>
    orpc.dashboard.services.get.queryOptions({ input: { id } }),
  categories: () =>
    orpc.dashboard.services.categories.list.queryOptions({
      staleTime: 60_000,
    }),
  bookings: () =>
    orpc.dashboard.services.bookings.list.queryOptions({ input: {} }),
  template: (serviceId: string) =>
    orpc.dashboard.services.template.get.queryOptions({
      input: { serviceId },
    }),
  installPreset: () =>
    orpc.dashboard.services.template.installPreset.mutationOptions(),
  materials: (includeArchived = false) =>
    orpc.dashboard.services.materials.list.queryOptions({
      input: { includeArchived },
    }),
  material: (id: string) =>
    orpc.dashboard.services.materials.get.queryOptions({ input: { id } }),
  materialCategories: () =>
    orpc.dashboard.services.materials.categories.list.queryOptions({
      input: {},
      staleTime: 60_000,
    }),
  listKey: () => orpc.dashboard.services.list.key(),
  categoriesKey: () => orpc.dashboard.services.categories.key(),
  bookingsKey: () => orpc.dashboard.services.bookings.key(),
  templateKey: () => orpc.dashboard.services.template.key(),
  materialsKey: () => orpc.dashboard.services.materials.key(),
  materialCategoriesKey: () =>
    orpc.dashboard.services.materials.categories.key(),
};

export const storefrontServicesQueries = {
  list: () => orpc.storefront.services.list.queryOptions(),
  get: (id: string) =>
    orpc.storefront.services.get.queryOptions({ input: { id } }),
  template: (id: string) =>
    orpc.storefront.services.template.queryOptions({ input: { id } }),
  evaluate: () => orpc.storefront.services.evaluate.mutationOptions(),
  requestQuote: () =>
    orpc.storefront.services.requestQuote.mutationOptions(),
};
